export const VIEWED_MIGRATED_ACCOUNTS_LOCAL_STORAGE_KEY =
  'frame-io--viewed-migrated-accounts';
export const CSS_VAR_SCRIM_DISPLAY = '--migrate-gate-scrim-display';
export const CSS_VAR_SCRIM_Z_INDEX = '--migrate-gate-scrim-z-index';
export const MIGRATION_STATUS_POLL_INVERVAL = 5000;

/**
 * After a migration is completed, users have a window of time to view
 * the migration flow. After this window has expired, they will be taken
 * straight to the app.
 * Note: this value should match the TTL of startedAt in Redis
 */
export const MIGRATION_DAY_WINDOW = 1;

/**
 * GraphQL `fioVersionMigration.status` typenames for accounts that should stay
 * on the V4 migration gate (not redirected to V3) while auto-migration is
 * required or in-flight.
 */
export const V4_AUTO_MIGRATION_IN_FLOW_STATUSES: readonly string[] = [
  'FioVersionMigrationMustMigrate',
  'FioVersionMigrationPending',
  'FioVersionMigrationInProgress',
];
